import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Cateringbanners = () => {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        const fetchBanners = async () => {
            try {
                setLoading(true);

                const token = localStorage.getItem("authToken");

                const response = await axios.get(
                    "testing.maamaas./catering/api/banners/getall",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                setBanners(response.data);
                setError("");

            } catch (err) {
                setError("Failed to load vendor banners.");
            } finally {
                setLoading(false);
            }
        };

        fetchBanners();
    }, []);

    const handleVendorClick = (vendorId) => {
        localStorage.setItem("vendorId", vendorId); // optional
        navigate(`/vendor-packages/${vendorId}`);
    };

    if (loading) return <h4 className="text-center mt-4">Loading vendors...</h4>;
    if (error) return <h4 className="text-danger text-center mt-4">{error}</h4>;

    return (
        <div className="container mt-4">
            <div className="row">
                {banners.map((banner) => (
                    <div
                        className="col-lg-6 col-md-6 mb-4"
                        key={banner.bannerId}
                    >
                        <div
                            className="card vendor-card shadow-sm border-0"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleVendorClick(banner.vendorId)}
                        >
                            <img
                                src={banner.companyBanner}
                                className="card-img-top"
                                alt={banner.companyName}
                                style={{ height: "220px", objectFit: "cover" }}
                            />

                            <div className="card-body text-center">
                                <h2 className="fw-bold">
                                    {banner.companyName}
                                </h2>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Cateringbanners;
